import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageMeta from '@/components/feature/PageMeta';
import HeroSection from './components/HeroSection';
import HotRecommendSection from './components/HotRecommendSection';
import CategorySection from './components/CategorySection';
import NbaSection from './components/NbaSection';
import LatestSection from './components/LatestSection';
import TestimonialSection from './components/TestimonialSection';

const homeSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "51动漫",
  "url": "https://www.51dm.com/",
  "description": "51动漫官网提供最新动漫下载与在线播放资源，同步更新NBA赛事视频。从热门新番到经典老片，这里是动漫迷和体育迷的随身追更站。",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://www.51dm.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  },
  "inLanguage": "zh-CN"
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "51动漫",
  "url": "https://www.51dm.com/",
  "description": "中国领先的动漫在线播放与下载平台，提供最新动漫资源和NBA赛事视频。",
  "foundingDate": "2018",
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "customer service",
    "email": "support@51dm.com"
  }
};

export default function Home() {
  return (
    <>
      <PageMeta
        title="51动漫 | 51动漫官网与51动漫下载 | 永久免费看动漫入口"
        description="51动漫官网提供最新动漫下载与在线播放资源，同步更新NBA赛事视频。从热门新番到经典老片，这里是动漫迷和体育迷的随身追更站。永久免费，高速流畅，支持手机与电脑观看。"
        keywords="51动漫, 51动漫官网, 51动漫下载, 51动漫永久免费看nba视频, 51动漫入口, 51动漫app, 51动漫最新地址, 动漫下载, NBA视频, 在线播放"
        canonicalUrl="https://www.51dm.com/"
        schemaData={[homeSchema, orgSchema]}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <HotRecommendSection />
          <CategorySection />
          <NbaSection />
          <LatestSection />
          <TestimonialSection />
        </main>
        <Footer />
      </div>
    </>
  );
}